"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardNumberElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useElement = require("./useElement");
var _useListener = require("./useListener");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CardNumberElementC = ({
  'aria-label': ariaLabel,
  autoComplete,
  bt,
  cardTypes,
  disabled,
  elementRef,
  enableCopy,
  iconPosition,
  id,
  inputMode,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onReady,
  placeholder,
  readOnly,
  skipLuhnValidation,
  style,
  validateOnChange,
  value,
  valueRef
}) => {
  const wrapperRef = (0, _react.useRef)(null);
  const element = (0, _useElement.useElement)(id, 'cardNumber', wrapperRef, {
    'aria-label': ariaLabel,
    autoComplete,
    cardTypes,
    disabled,
    enableCopy,
    iconPosition,
    inputMode,
    placeholder,
    readOnly,
    skipLuhnValidation,
    style,
    targetId: id,
    validateOnChange,
    value
  }, bt, elementRef, valueRef);
  (0, _useListener.useListener)('ready', element, onReady);
  (0, _useListener.useListener)('change', element, onChange);
  (0, _useListener.useListener)('focus', element, onFocus);
  (0, _useListener.useListener)('blur', element, onBlur);
  (0, _useListener.useListener)('keydown', element, onKeyDown);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    ref: wrapperRef
  });
};
const CardNumberElement = /*#__PURE__*/_react.default.forwardRef(function CardNumberElement(props, ref) {
  return /*#__PURE__*/_react.default.createElement(CardNumberElementC, _extends({}, props, {
    elementRef: ref
  }));
});
exports.CardNumberElement = CardNumberElement;